import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "./images/logo.png";
import barImg from "./images/barImage.png";

import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import arrowWhite from "./icons/arrow-down-white.png";
import placeholder from "./images/barPlaceholderAlt.png";
import { withTranslation } from "react-i18next";
import logoHeader from "./images/logoheader.png";
import logoHeaderSvg from "./images/logoheadersvg.svg";
import { Alert, Button } from "react-bootstrap";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";
import firebase from "firebase/compat/app";
// import "bootstrap/dist/css/bootstrap.min.css";

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      barInfo: {},
      uid: "",
      userEmail: "",
      url: "",
      warningVar: false,
      newBarTitle: "",
      data: [],
      isAdmin: false,
      renderList: (
        <div className="spinnerDiv">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      ),
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.loadBarDetails();
  }

  loadBarDetails() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const tokenResult = await user.getIdTokenResult();
        this.setState({ isAdmin: !!tokenResult.claims.admin });
        const ref = firebase.firestore().collection("owners").doc(user.uid);
        this.setState({ uid: user.uid, userEmail: user.email });

        ref
          .get()
          .then((doc) => {
            if (doc.exists) {
              const barList = doc?.data()?.bars;

              if (barList.length > 0) {
                Promise.all(
                  barList.map(async (element) => {
                    const barDoc = await firebase
                      .firestore()
                      .collection("bar2")
                      .doc(element)
                      .get();
                    return barDoc.data();
                  })
                ).then((barData) => {
                  let filterdata = barData?.filter(
                    (item) => item != undefined || item != null
                  );

                  console.log("====================================");
                  console.log("filteredArray" + JSON.stringify(filterdata));
                  console.log("====================================");

                  const fetchURLs = async () => {
                    try {
                      const urlData = await Promise.all(
                        filterdata.map(async (x) => {
                          try {
                            const url = await firebase
                              .storage()
                              .ref("barImages")
                              .child(x.id)
                              .getDownloadURL();

                            return { ...x, newurl: url || placeholder };
                          } catch (error) {
                            console.error("Error fetching URL:", error.message);
                            return { ...x, newurl: placeholder }; // If there's an error, use placeholder
                          }
                        })
                      );

                      const newData = urlData.sort((a, b) => {
                        const idA = parseInt(a?.id?.substr(-4), 16); // Convert the last 4 characters of "id" to a number
                        const idB = parseInt(b?.id?.substr(-4), 16);

                        return idA - idB;
                      });

                      this.setState({ data: newData });
                      this.setState({ loading: false });
                    } catch (error) {
                      console.error("Error:", error.message);
                    }
                  };
                  fetchURLs();
                });
              } else {
                // bar list is empty
                this.setState({ loading: false });
              }
            } else {
              // owner document does not exist for this user
              this.setState({ loading: false });
            }
          })
          .catch((error) => {
            console.log("Dashboard load error: " + error);
            this.setState({ loading: false });
          });
      } else {
        this.props.history.push("/login");
      }
    });
  }

  toggleOffCanvas() {
    this.setState({ offCanvas: !this.state.offCanvas });
    if (!this.state.offCanvas) {
      document.getElementById("offCanvas").style.right = "0px";
    } else {
      document.getElementById("offCanvas").style.right = "-300px";
    }
  }

  softDeleteOwnerAccount = async () => {
    const uid = firebase.auth().currentUser.uid;
    console.log("uid==>" + JSON.stringify(uid));

    try {
      // Fetch the owner's document
      const ownerDoc = await firebase
        .firestore()
        .collection("owners")
        .doc(uid)
        .get();

      console.log("OwnerDoc==>" + JSON.stringify(ownerDoc));

      if (ownerDoc.exists) {
        const barIds = ownerDoc.data().bars;

        // Soft delete each bar document
        const barSoftDeletions = barIds.map((barId) => {
          return firebase.firestore().collection("bar2").doc(barId).update({
            deleted: true,
            deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
          });
        });

        await Promise.all(barSoftDeletions);

        // Soft delete the owner's document
        await firebase.firestore().collection("owners").doc(uid).update({
          deleted: true,
          deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });

        // Sign out the user
        await firebase.auth().signOut();

        // Redirect to login or home page
        this.props.history.push("/login");
      }
    } catch (error) {
      console.error("Error soft deleting account and bars: ", error.message);
    }
  };

  async addBar() {
    this.setState({ loading: true });
    const uid = firebase.auth().currentUser.uid;

    try {
      const ownerRef = firebase.firestore().collection("owners").doc(uid);
      const ownerDoc = await ownerRef.get();

      let length = 1;
      // Default to the signed-in user's own email — the security rule
      // requires the new bar2 doc's email to match it exactly.
      let email = firebase.auth().currentUser.email || "";
      const existingBars = ownerDoc.exists ? ownerDoc.data().bars || [] : [];
      if (existingBars.length > 0) {
        const lastId = existingBars[existingBars.length - 1];
        length = parseInt(lastId.slice(uid.length), 10) + 1;
      }
      if (ownerDoc.exists && ownerDoc.data().email) {
        email = ownerDoc.data().email;
      }

      const barId = uid + length;
      const info = {
        adress: "Enter address",
        category: [],
        coordinates: {
          latitude: 0,
          longitude: 0,
        },
        // NOTE: this object used to have a second `email: ""` key further
        // down, which (duplicate keys last-one-wins in JS) silently blanked
        // out the real email above on every write. The security rule checks
        // this field against the signed-in user's own email, so every bar
        // created from this screen was rejected with "Missing or
        // insufficient permissions" — removing the duplicate fixes it.
        email,
        events: [],
        hours: {
          monday: "00:00-00:00",
          tuesday: "00:00-00:00",
          wednesday: "00:00-00:00",
          thursday: "00:00-00:00",
          friday: "00:00-00:00",
          saturday: "00:00-00:00",
          sunday: "00:00-00:00",
        },
        id: barId,
        link: "",
        name: this.state.newBarTitle,
        number: "",
        facebook: "",
        instagram: "",
        food: false,
        student: false,
        subscriptionId: null,
        created: new Date(),
        trial: true,
        subscription: 0,
      };

      await firebase.firestore().collection("bar2").doc(barId).set(info);
      await ownerRef.update({
        bars: [...existingBars, barId],
      });

      localStorage.setItem("info", JSON.stringify(info));
      this.props.history.push("/overview");
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  }

  handleWarning = () => {
    if (!this.state.warningVar) {
      document.getElementById("outerWarning").style.display = "initial";
      this.setState({
        warningVar: true,
      });
    } else {
      document.getElementById("outerWarning").style.display = "none";
    }
    this.setState({
      warningVar: false,
    });
  };

  handleRevert = () => {
    document.getElementById("outerWarning").style.display = "none";
    this.setState({
      warningVar: false,
    });
  };

  regBar() {
    if (!this.state.warningVar) {
      document.getElementById("outerWarning").style.display = "initial";
      this.setState({
        warningVar: true,
      });
    } else {
      document.getElementById("outerWarning").style.display = "none";
    }
  }

  trimString(str, limit) {
    if (typeof str !== "string" || typeof limit !== "number") {
      // Check if input types are valid
      return "Invalid input types";
    }

    // Trim and add ellipsis if necessary
    let newStr = str.trim().substr(0, limit);

    if (str.trim().length > limit) {
      newStr = newStr + " ...";
    }

    return newStr;
  }

  render() {
    const { t } = this.props;
    let hamburgerStyle = this.state.offCanvas
      ? "hamburger hamburger--collapse is-active"
      : "hamburger hamburger--collapse";
    return (
      <div>
        <Helmet>
          <style>{"body { background-color: #F7F7F7 !important; }"}</style>
        </Helmet>
        <div className="outerWarning" id="outerWarning">
          <div className="modalcontent">
            <div className="innerWarning">
              <p className="warningText">{t("dashboard.whatName")}</p>
              <input
                className="longInput contactInput"
                type="text"
                value={this.state.newBarTitle}
                onChange={(event) => {
                  this.setState({ newBarTitle: event.target.value });
                }}
              ></input>
              <button
                className="warningButton goBackBtn "
                onClick={this.handleRevert}
              >
                {t("dashboard.cancel")}
              </button>
              <button
                className="warningButton "
                onClick={() => {
                  this.addBar();
                  this.handleWarning();
                }}
              >
                {t("dashboard.add")}
              </button>
            </div>
          </div>
        </div>
        <div className="header">
          <div className="logoBar">
            <img className="logo" src={logo} alt="Bar Zone logo"></img>
            <div className="logoHeader-content">
              <img
                className="logoHeader"
                src={logoHeaderSvg}
                alt="Bar Zone logo"
              ></img>
            </div>

            <Dropdown className="settingsNav">
              <Dropdown.Toggle
                className="settingsToggle"
                variant="success"
                id="dropdown-basic"
              >
                {this.state.userEmail}
                <img
                  className="arrowDownWhite"
                  src={arrowWhite}
                  alt="arrow"
                ></img>
              </Dropdown.Toggle>
              <Dropdown.Menu className="settingsDrop">
                {/*<Dropdown.Item className="settingsItem item1">Settings</Dropdown.Item>*/}
                <Dropdown.Item
                  className="settingsItem item2"
                  onClick={() => firebase.auth().signOut()}
                >
                  {t("dashboard.logOut")}
                </Dropdown.Item>
                {/* <Dropdown.Item
                  className="settingsItem item2"
                  onClick={() => this.softDeleteOwnerAccount()}
                >
                  {"Delete Account"}
                </Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
            <button
              class={hamburgerStyle}
              type="button"
              onClick={this.toggleOffCanvas.bind(this)}
            >
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
          <div id="offCanvas" className="offCanvas">
            <div className="offCanvasInner">
              <div className="offCanvasLinkDiv">
                {/*<a className="offCanvasLink">Settings</a>*/}
                <a
                  className="offCanvasLink"
                  onClick={() => firebase.auth().signOut()}
                >
                  {t("dashboard.logOut")}
                </a>
              </div>
            </div>
            <div className="offCanvasLogoDiv">
              <img className="logoSmall" src={logo} alt="Bar Zone logo"></img>
            </div>
          </div>
          <div className="titleBar boxShadow">
            <div className="outerTitleBar">
              <div className="innerTitleBar">
                <p className="pageTitle">{t("dashboard.dashboard")}</p>
                <a
                  className="yellowBtn floatRight linkStyle"
                  onClick={() => this.regBar()}
                >
                  {t("dashboard.registerBar")}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="outerDashboard">
          <div className="innerDashboard">
            {/* {this.state.loading == true && (

            )} */}
            {this.state.loading == false && this.state.data?.length > 0 ? (
              this.state.data
                .filter((data) => !data.deleted) // Filter out items where deleted is true
                .map((data) => {
                  return (
                    <div
                      className="barSelectDashboard"
                      onClick={() => {
                        localStorage.setItem("info", JSON.stringify(data));
                        this.props.history.push("/overview");
                      }}
                    >
                      <img
                        className="barImgDashboard"
                        src={data?.newurl}
                        alt="Bar Image"
                      ></img>
                      <p className="barSelectTitle">
                        {" "}
                        {this.trimString(data?.name, 21)}
                      </p>
                      <p className="barSelectAddress">
                        {this.trimString(data?.adress, 30)}
                      </p>
                    </div>
                  );
                })
            ) : this.state.loading == true ? (
              <div className="spinnerDiv">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              this.state.data?.length == 0 && (
                <div className="spinnerDiv">
                  <h3 className="noBarsFound">No bars Found :(</h3>
                </div>
              )
            )}
          </div>
        </div>

        {/* Platform-wide Badges section — admin only */}
        {this.state.isAdmin && (
          <div style={{ maxWidth: 900, margin: '32px auto 40px', padding: '0 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1a1a1a' }}>🏆 Badges</h3>
              <button
                className="yellowBtn"
                onClick={() => this.props.history.push('/badges')}
              >
                Manage Badges
              </button>
            </div>
            <p style={{ color: '#666', fontSize: 14, margin: 0 }}>
              Manage badge definitions awarded to app users based on their activity.
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(Dashboard);
